const basketConstants = {
  selectors: {
    basketAlert: ".basket-alert",
    basketAlertClose: ".basket-alert .close",    
    basketNotificationBar: ".basket--quick-view",
    basketNotificationBarClose: ".basket--quick-view .close",
    basketCancel: "[data-cancel-order]",
    basketCheckout: "[data-checkout]",
    basketContainer: "#basketContainer",
    basketExtras: "[data-basket-extras]",
    basketSubmit: ".basket-submit",
    basketUpgrade: "[data-upgrade-notice]",
    basketUpgrades: "[data-show-upgrades]",
    basketRemoveAttribute: "[data-basket-remove]",
    basketUpdateAttribute: "[data-basket-change]",
    checkoutButton: "[data-checkout-button]",
    emptyBasketFlag: "#emptyBasket",
    expiryText: ".expiry",
    listingLink: ".back-to-listing",
    remainingTime: "[data-remaining-time]",
    standardMsg: ".standard-msg",    
    timeWarning: ".time-warning",
    basketPageIdHiddenField: "#basketPageId",
    upgradeBasketItemAttribute: "[data-basket-upgrade]",
    closeButton: "button.close",
    basketIndicator: "[data-basket-indicator]",
    basketExpiryNotice: ".basket-expiry-notice"
  },
  defaults: {
    basketAlertTimeout: 5000,
    basketAlertLocalStorageKey: "basketAlertDismissed",
  },
  urls: {
    upgradePath: "/upgrade/",
    payment: {
      create: "/api/payment/create-payment-intent",
      update: "/api/payment/update-payment-intent",
      reward_points: "/api/payment/reward-points",
      rewards_registered: "/api/payment/registered-for-rewards"
    },
    basketV2: {
      get: "/api/v2/basket",
      content: "/api/v2/basket/content",
      checkout_summary: "/api/v2/basket/checkout-summary",
      notification_bar: "/api/v2/basket/notification-bar",
      create: "/api/v2/basket/create",
      add: "/api/v2/basket/add",
      remove: "/api/v2/basket/remove",
      update: "/api/v2/basket/update",
      abandon: "/api/v2/basket/abandon",
      limits: "/api/v2/basket/limits",
      delivery_method: "/api/v2/basket/delivery-method",
      delivery_details: "/api/v2/basket/delivery-details",
      promo_code: "/api/v2/basket/promo-code",
      gift_card: "/api/v2/basket/gift-card",
      donation: "/api/v2/basket/donation"
    },
    eventV2: {
      limits: (id: number) => `/api/v2/basket/limits/event/${id}`,
    },
  },
  errorCodes: {
    integrationError: 0,
    fieldValidationError: 2
  }
};

export default basketConstants;
